(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementTelehealthInformedConsentComponent', agreementTelehealthInformedConsentComponent);

    agreementTelehealthInformedConsentComponent.$inject = [];

    function agreementTelehealthInformedConsentComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementTelehealthInformedConsentController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-telehealth-informed-consent.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementTelehealthInformedConsentController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementTelehealthInformedConsentController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
